//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === STYLES ===
import { useTheme } from '@mui/material/styles';
import {
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

// === COMPONENTS ===
import { RoleModules } from './RoleModules';

//#endregion

//-----------------------------------------------------------------
export function RoleRow( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const {
    role       ,
    modules    ,
    removeRole ,
  } = props;

  const theme = useTheme();

  const [ modules_assigned  , setModulesAssigned  ] = useState([]);
  const [ modules_available , setModulesAvailable ] = useState([]);
  const [ deleteRoleConfirmDialog, setDeleteRoleConfirmDialog] = useState(false);

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    if (!role || !role.modules || !modules) return;

    const role_modules = role.modules.map((module) => module.ModuleName);
    const assigned_modules = modules.filter((x) =>
      role_modules.includes(x.ModuleName)
    );
    const available_modules = modules.filter(
      (x) => !role_modules.includes(x.ModuleName)
    );

    setModulesAssigned (assigned_modules);
    setModulesAvailable(available_modules);
  }, [role]);

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function handleClick_DeleteRoleDialog() {
    //-----------------------------------------------------------------
    setDeleteRoleConfirmDialog(true);
  };

  //-----------------------------------------------------------------
  function handleConfirm_DeleteRoleDialog() {
    //-----------------------------------------------------------------
    removeRole(role.id);
    setDeleteRoleConfirmDialog(false);
  };

  //-----------------------------------------------------------------
  function handleAbort_DeleteRoleDialog() {
    //-----------------------------------------------------------------
    setDeleteRoleConfirmDialog(false);
  };

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const isReservedRole = [
      'default',
      'admin',
      'submitter',
      'keyer',
      'manager',
      'reporter',
    ].includes(role.RoleName);
    const isKeyerRole = role.RoleName === 'keyer';
    const tempAvailableMods =
      isReservedRole && !isKeyerRole ? [] : modules_available;
    const delButton = isReservedRole ? null : (
      <Tooltip title='Delete Role'>
        <IconButton
          aria-label='delete-role'
          aria-controls='delete-role'
          color='primary'
          disabled={isReservedRole}
          onClick={handleClick_DeleteRoleDialog}
          name='delete_role_btn'
        >
          <DeleteForeverIcon fontSize='small' />
        </IconButton>
      </Tooltip>
    );

    return (
      <TableRow
        sx={
          isReservedRole && !isKeyerRole ? {
            backgroundColor: theme.palette.background.default,
          } : ''
        }
        key={role.id}
      >
        <TableCell>{delButton}</TableCell>
        <TableCell>{role.RoleName}</TableCell>
        <RoleModules
          roleModules      = { modules_assigned  }
          availableModules = { tempAvailableMods }
          roleId           = { role.id           }
        />
        {displayDeleteRoleDialog()}
      </TableRow>
    );
  }

  //-----------------------------------------------------------------
  function displayDeleteRoleDialog() {
    //-----------------------------------------------------------------
    return (
      <Dialog
        open={deleteRoleConfirmDialog}
        onClose={handleAbort_DeleteRoleDialog}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {'Confirm Role Deletion'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to DELETE the Role? Be advised, this action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleAbort_DeleteRoleDialog}
            color='primary'
            autoFocus
            name='abort_role_delete_dialog_btn'
          >
            Abort
          </Button>
          <Button
            onClick={handleConfirm_DeleteRoleDialog}
            color='primary'
            autoFocus
            name='confirn_role_delete_dialog_btn'
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  //#endregion

  return display();
}
